import { render } from "./Sticky.vue?vue&type=template&id=5267a0b9"
import script from "./Sticky.vue?vue&type=script&lang=js"
export * from "./Sticky.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__